const prepare = {
        "before work": [
            {
                "name": "gmail.com",
                "link": "https://gmail.com",
                "thumbnail": "gmail.svg",
                "img": "imgPath",
                "hint": "email"
            },
            {
                "name": "mail.ru",
                "link": "https://mail.ru/",
                "thumbnail": "mail.svg",
                "img": "imgPath",
                "hint": "email"
            },
            {
                "name": "gDrive",
                "link": "https://drive.google.com/drive/my-drive",
                "thumbnail": "gDrive.svg",
                "img": "imgPath",
                "hint": "storage"
            },
            {
                "name": "mailCloud",
                "link": "",
                "thumbnail": "mailCloud.svg",
                "img": "imgPath",
                "hint": "storage"
            },
            {
                "name": "dropbox",
                "link": "https://www.dropbox.com/",
                "thumbnail": "dropbox.svg",
                "img": "imgPath",
                "hint": "storage"
            },
            {
                "name": "calendar",
                "link": "https://calendar.google.com/calendar",
                "thumbnail": "calendar.svg",
                "img": "imgPath",
                "hint": "planer"
            }
        ],
        "social": [
            {
                "name": "linkedIn",
                "link": "https://www.linkedin.com/",
                "thumbnail": "linkedin.svg",
                "img": "imgPath",
                "hint": "en"
            },
            {
                "name": "facebook",
                "link": "https://www.facebook.com/",
                "thumbnail": "facebook.svg",
                "img": "imgPath",
                "hint": "en"
            },
            {
                "name": "vk",
                "link": "https://vk.com/",
                "thumbnail": "vk.svg",
                "img": "imgPath",
                "hint": "ru"
            }  
        ],
        "sound": [
            {
                "name": "fitradio",
                "link": "http://www.fitradio.com/music#_=_",
                "thumbnail": "fitRadio.svg",
                "img": "imgPath",
                "hint": "music"
            },
            {
                "name": "loungeFM",
                "link": "http://www.loungefm.com.ua/",
                "thumbnail": "loungeFm.svg",
                "img": "imgPath",
                "hint": "music"
            },
            {
                "name": "radio.obozrevatel",
                "link": "http://radio.obozrevatel.com/player/73",
                "thumbnail": "rOb.svg",
                "img": "imgPath",
                "hint": "music"
            },
            {
                "name": "webStandartes",
                "link": "https://soundcloud.com/web-standards",
                "thumbnail": "soundcloud.svg",
                "img": "imgPath",
                "hint": "ru"
            },
            {
                "name": "radioJS",
                "link": "https://radiojs.ru/",
                "thumbnail": "js-radio.svg",
                "img": "imgPath",
                "hint": "ru"
            },
            {
                "name": "devZen",
                "link": "http://devzen.ru/",
                "thumbnail": "devZen.svg",
                "img": "imgPath",
                "hint": "ru"
            },
            {
                "name": "razbor-poletov",
                "link": "http://razbor-poletov.com/",
                "thumbnail": "flight.svg",
                "img": "imgPath",
                "hint": "ru"
            },
            {
                "name": "radio-t",
                "link": "https://radio-t.com/",
                "thumbnail": "tRadio.svg",
                "img": "imgPath",
                "hint": "ru"
            },
        ],
        "tools": [
            {
                "name":"GitHub",
                "link":"https://github.com/",
                "thumbnail": "github.svg",
                "img": "",
                "hint": "repo"
            },
            {
                "name":"Bitbucket",
                "link":"https://bitbucket.org/",
                "thumbnail": "bitbucket.svg",
                "img": "",
                "hint": "repo"
            },
            {
                "name":"gist",
                "link":"https://gist.github.com/",
                "thumbnail": "gists.svg",
                "img": "",
                "hint": "notes"
            },
            {
                "name":"CodePen",
                "link":"http://codepen.io/",
                "thumbnail": "codePen.svg",
                "img": "",
                "hint": "editor"
            },
            {
                "name":"JSFiddle",
                "link":"https://fiddle.jshell.net/",
                "thumbnail": "jsfiddle.svg",
                "img": "",
                "hint": "editor"
            },
            {
                "name":"repl.it",
                "link":"https://repl.it/",
                "thumbnail": "repl.svg",
                "img": "",
                "hint": "editor"
            }
        ],
        "environment": [
            {
                "name": "node",
                "link":"https://nodejs.org/uk/",
                "thumbnail": "node.svg",
                "img": "",
                "hint": "engine"
            },
            {
                "name": "git",
                "link":"https://git-scm.com/",
                "thumbnail": "git.svg",
                "img": "",
                "hint": "VCS"
            },
            {
                "name": "sublimeText",
                "link":"https://www.sublimetext.com/",
                "thumbnail": "sublime.svg",
                "img": "",
                "hint": "editor"
            },
            {
                "name":"uikit",
                "img": "",
                "thumbnail":"ukit.svg",
                "hint": "",
                "link":"https://getuikit.com/"
            },
            {
                "name": "vim",
                "link":"https://github.com/vim/vim",
                "thumbnail": "vim.svg",
                "img": "",
                "hint": "editor"
            },
            {
                "name":"webpack",
                "link":"https://webpack.github.io/",
                "thumbnail": "webpack.svg",
                "img": "",
                "hint": "packer"
            },
            {
                "name":"gulp",
                "link":"https://gulpjs.com/",
                "thumbnail": "gulp.svg",
                "img": "",
                "hint": "taskruner"
            }    
        ],
        "other": [
            {
                "name":"Wireframe.cc",
                "img": "",
                "thumbnail": "wireframe.svg",
                "link":"https://wireframe.cc/",
                "hint": "scratch"
            },
            {
                "name":"Markdown",
                "img": "",
                "thumbnail": "markdown.svg",
                "link":"https://github.com/adam-p/markdown-here/wiki/Markdown-Cheatsheet",
                "hint": "git decor"
            }
        ]
}

export default prepare;


// WEBPACK FOOTER //
// ./src/assets/db/prepare.js